













import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ProcessingIcon from '@/components/icons/Processing.vue';

@Component({
  components: {
    Typography,
    ProcessingIcon
  }
})
export default class Processing extends Vue {
  get tPrefix() {
    return 'inviteCustomerInStore.processing';
  }
}
